import adminReducer from './admin-reducer';
export default adminReducer;